import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconCloseCircle: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#F04438',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00004 0.833008C4.04804 0.833008 0.833374 4.04834 0.833374 7.99967C0.833374 11.951 4.04804 15.1663 8.00004 15.1663C11.952 15.1663 15.1667 11.951 15.1667 7.99967C15.1667 4.04834 11.952 0.833008 8.00004 0.833008ZM8.00004 14.1663C4.59937 14.1663 1.83337 11.4003 1.83337 7.99967C1.83337 4.59901 4.59937 1.83301 8.00004 1.83301C11.4007 1.83301 14.1667 4.59901 14.1667 7.99967C14.1667 11.4003 11.4007 14.1663 8.00004 14.1663ZM10.3534 6.35303L8.70671 7.99967L10.3534 9.64632C10.5487 9.84165 10.5487 10.1583 10.3534 10.3537C10.256 10.451 10.128 10.5003 10 10.5003C9.87204 10.5003 9.74404 10.4517 9.64671 10.3537L8.00004 8.70699L6.35337 10.3537C6.25604 10.451 6.12804 10.5003 6.00004 10.5003C5.87204 10.5003 5.74404 10.4517 5.64671 10.3537C5.45138 10.1583 5.45138 9.84165 5.64671 9.64632L7.29338 7.99967L5.64671 6.35303C5.45138 6.15769 5.45138 5.841 5.64671 5.64567C5.84204 5.45034 6.15871 5.45034 6.35404 5.64567L8.00071 7.29236L9.64738 5.64567C9.84271 5.45034 10.1594 5.45034 10.3547 5.64567C10.5487 5.841 10.5487 6.15836 10.3534 6.35303Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconCloseCircle;
